module.exports = __webpack_public_path__ + "9fce318dfddacf93f9afde006286c0e1.png";